var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "interactive-image" }, [
    _c(
      "div",
      {
        ref: "stage",
        staticClass: "interactive-stage",
        on: {
          wheel: function ($event) {
            $event.preventDefault()
            return _vm.wheel.apply(null, arguments)
          },
          mousedown: function ($event) {
            $event.preventDefault()
            return _vm.start.apply(null, arguments)
          },
          dblclick: _vm.reset,
        },
      },
      [
        _c("img", {
          style: _vm.imageStyle,
          attrs: { src: _vm.src, alt: _vm.name, draggable: "false" },
          on: {
            load: function ($event) {
              return _vm.$emit("load")
            },
            error: function ($event) {
              return _vm.$emit("error")
            },
          },
        }),
      ]
    ),
    _c("div", { staticClass: "interactive-tools" }, [
      _c(
        "button",
        {
          attrs: { type: "button", "aria-label": "缩小图片" },
          on: {
            click: function ($event) {
              return _vm.zoom(_vm.scale / 1.2)
            },
          },
        },
        [_vm._v("−")]
      ),
      _c("output", [_vm._v(_vm._s(Math.round(_vm.scale * 100)) + "%")]),
      _c(
        "button",
        {
          attrs: { type: "button", "aria-label": "放大图片" },
          on: {
            click: function ($event) {
              return _vm.zoom(_vm.scale * 1.2)
            },
          },
        },
        [_vm._v("＋")]
      ),
      _c("button", { attrs: { type: "button" }, on: { click: _vm.reset } }, [
        _vm._v("适应窗口"),
      ]),
      _c(
        "button",
        {
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.rotation = (_vm.rotation + 90) % 360
            },
          },
        },
        [_vm._v("旋转")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }